import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import './StandardRadio.scss';
import classNames from 'classnames';
import { t } from 'i18next';
import { capitalizeFirstLetter } from '../../utils/helpers';
import { OptionI, ValidationObj } from '../../../types/interface';
import validationUtils from '../../utils/validationUtils';

interface StandardRadioI {
  label?: string;
  disabled?: boolean;
  value: string;
  onChange: (
    value: string | number | undefined,
    name: string | undefined
  ) => void;
  className: string;
  helpText?: string;
  errorText?: string;
  error?: boolean;
  showError?: boolean;
  validations?: ValidationObj[];
  options: OptionI[];
  name?: string;
  outerClassName?: string;
}

const CustomStandardRadio = (props: StandardRadioI) => {
  const [valid, setValid] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [errorKey, setErrorKey] = useState<string | undefined>('');
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    checkValidity(props.value);
  }, []);

  useEffect(() => {
    checkValidity(props.value);
  }, [props.validations, dirty, errorText, props.value]);

  const renderLabel = () => {
    const { label } = props;

    if (label) {
      return (
        <div className="standard-dropdown-label ps-0 fs-16">
          {capitalizeFirstLetter(label)}
        </div>
      );
    }
    return null;
  };

  const renderHelp = () => {
    const { helpText } = props;

    if (helpText) {
      return <Form.Text className="text-muted">{helpText}</Form.Text>;
    }
    return null;
  };

  const renderError = () => {
    if (errorText && (dirty || props.showError)) {
      return (
        <Form.Text className="text-danger error standard-error-text">
          {errorKey
            ? capitalizeFirstLetter(t(errorKey))
            : capitalizeFirstLetter(errorText)}
        </Form.Text>
      );
    }
    return null;
  };

  const checkValidity = (value: string | number | undefined) => {
    let isValid = true;
    let errorText = '';
    let errorKey: string | undefined = '';
    for (const validation of props.validations || []) {
      if (validation.type != 'checkFormValidity') {
        if (
          !validation.disabled &&
          !validationUtils[validation.type](value!, validation)
        ) {
          errorText = validation.message;
          errorKey = validation.key;
          isValid = false;
          break;
        }
      }
    }
    setValid(isValid);
    setErrorText(errorText);
    setErrorKey(errorKey);
  };

  const onBlur = () => {
    setDirty(true);
  };

  const onChange = (value: string | number | undefined) => {
    if (props.disabled) {
      return;
    } else {
      checkValidity(value);
      props.onChange(value, props.name);
    }
  };

  const generateClassname = () => {
    return `${props.className} `;
  };

  return (
    <>
      <Form.Group className="mb-3 text-start" id="standard-checkbox">
        {renderLabel()}
        <div className={`${props.outerClassName}`}>
          {props.options.map((option: OptionI) => {
            return (
              <div
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                }}
              >
                <Form.Check
                  disabled={props.disabled}
                  onChange={() => {
                    window.formIsDirty = true;
                  }}
                  inline
                  className={classNames(generateClassname(), 'standard-radio', {
                    'cursor-pointer': !props.disabled
                  })}
                  label={option.label}
                  checked={option.value === props.value}
                  onBlur={onBlur}
                />
              </div>
            );
          })}
        </div>
        {valid ? renderHelp() : renderError()}
      </Form.Group>
    </>
  );
};

export default CustomStandardRadio;
export const StandardRadio = React.memo(CustomStandardRadio);
